/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types';
import React, { useState, useRef } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import InfoBox from '../../common/EnhancedGridFeature/InfoBox';
import infoIcon from '../../../images/insight360/info-icon_black_outline.png';
import {
  CAC_AXES_DISPLAY_FRONT_VIEW,
  CAC_AXES_DISPLAY_TOP_VIEW,
  CAC_AXES_DISPLAY_SIDE_VIEW
} from '../CacConstants';

const CorrAxisSelectBlock = props => {
  const { chartView, setChartView } = props;
  const infoBoxRef = useRef(null);
  const [dropPanels, setDropPanels] = useState([]);

  const buildInfoBox = () => {
    const buildRow = (title, text) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div style={{ fontWeight: '700', minWidth: '80px' }}>{title}</div>
          <div>{text}</div>
        </div>
      );
    };

    if (dropPanels.length === 0) {
      const ibp = [];
      ibp.push(
        <div className="corr-axis-popover-outer">
          {buildRow('Front View:', 'Axis 1 and Axis 2')}
          {buildRow('Top View:', 'Axis 1 and Axis 3')}
          {buildRow('Side View:', 'Axis 2 and Axis 3')}
        </div>
      );
      setDropPanels(ibp);
    }
    return dropPanels;
  };

  // custom CSS checkbox
  // http://codepen.io/derekmorash/pen/Eydxab/
  return (
    <div className="axis-selection-block" data-test="CorrAxisSelectBlock">
      <div className="genericTitle axis-title">
        <div>Axes Display</div>
        <div className="view-axis-tooltip">
          <InfoBox
            ref={infoBoxRef}
            Panels={buildInfoBox()}
            updatePanels={buildInfoBox}
            Positions={['top']}
            Align="start"
            InfoBoxButtonInner={
              <img className="ibox-axis-info" src={infoIcon} alt="(i)" />
            }
            containerClassName="corr-popover-axis-info"
          />
        </div>
      </div>
      <div className="axis-checkboxes">
        <AxisCheckBox
          title={CAC_AXES_DISPLAY_FRONT_VIEW}
          id="axis1"
          value={[1, 2]}
          chartView={chartView}
          setChartView={setChartView}
        />
        <AxisCheckBox
          title={CAC_AXES_DISPLAY_TOP_VIEW}
          id="axis2"
          value={[1, 3]}
          chartView={chartView}
          setChartView={setChartView}
        />
        <AxisCheckBox
          title={CAC_AXES_DISPLAY_SIDE_VIEW}
          id="axis3"
          value={[2, 3]}
          chartView={chartView}
          setChartView={setChartView}
        />
      </div>
    </div>
  );
};

CorrAxisSelectBlock.propTypes = {
  chartView: PropTypes.arrayOf(PropTypes.number),
  setChartView: PropTypes.func,
};

// #region axisCheckBox
const AxisCheckBox = props => {
  const { title, id, value, chartView, setChartView } = props;
  const selected = _.isEqual(chartView, value);

  const onHandleChange = valsX => {
    if (!_.isEqual(valsX, chartView)) setChartView(valsX);
  };

  return (
    <div className="axis-checkbox">
      <input
        type="checkbox"
        className="hidden-box" // breaks onChange
        id={id}
        name="axisGroup"
        value={value}
        checked={selected}
        onChange={() => onHandleChange(value)}
      />
      <label htmlFor={id} className="check--label">
        <div style={{ display: 'flex' }}>
          <div>
            <span className="check--label-box" />
          </div>
          <div
            className={classNames('check--label-text', {
              'check--label-text-selected': selected,
            })}
          >
            {title}
          </div>
        </div>
      </label>
    </div>
  );
};

AxisCheckBox.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.number),
  chartView: PropTypes.arrayOf(PropTypes.number),
  setChartView: PropTypes.func,
};
// #endregion

export default CorrAxisSelectBlock;
